import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';

const Employees = () => import('@/components/employees/Employees.vue');

const employeesRoutes: RouteRecordRaw[] = [
  {
    path: '/employees',
    name: 'Employees',
    component: Employees,
    meta: {
      role: Role.STAFF,
    },
  },
];

export default employeesRoutes;
